import React from 'react';

export interface TableTitleProps extends React.HTMLAttributes<HTMLDivElement> {}

export const TableTitleBase: React.FunctionComponent<TableTitleProps> = props => <div {...props} />;
